<template>
  <VanBtn class="submit-btn" color="" size="large">
    <div class="text">
      <slot></slot>
      <div v-if="countdown" class="time">{{ countdown }}</div>
    </div>
  </VanBtn>
</template>

<script>
import { Button as VanBtn } from "vant";
export default {
  name: "SubmitBtn",
  props: {
    countdown: {
      type: String,
      default: ""
    }
  },
  methods: {},
  components: {
    VanBtn
  }
};
</script>

<style lang="scss" scoped>
@import "../css/var.scss";
.submit-btn {
  width: 90px;
  height: 40px;
  background-color: $--color-primary !important;
  line-height: 12px;
  border-radius: 2px;
  border: none;
  .text {
    font-size: 13px;
    color: #fff;
  }
  .time {
    color: #f3f5f9;
    font-size: 9px;
  }
}
</style>
